import styled, { css } from 'styled-components';

type TLabel = {
  width: number;
  disabled?: boolean;
};

export const Label = styled.label<TLabel>`
  display: flex;
  flex-direction: column;
  width: ${(p) => p.width * 100}%;

  padding: ${(p) => p.theme.spacing.small};

  opacity: 1;

  transition: opacity 0.3s;
  will-change: opacity;

  > span {
    margin-bottom: ${(p) => p.theme.spacing.nano};
  }

  ${(p) =>
    p.disabled &&
    css`
      opacity: 0.6;
    `};

  & textarea {
    line-height: ${(p) => p.theme.font.xLarge};
  }
`;

export const Error = styled.span`
  display: block;
  padding-top: ${(p) => p.theme.spacing.nano};
  color: ${(p) => p.theme.colors.danger};
`;
